module.exports = __webpack_public_path__ + "static/media/64-iveco-mercedes.c89153f1.jpg";